import { render, staticRenderFns } from "./ActivityHistory.vue?vue&type=template&id=2bce794c&"
import script from "./ActivityHistory.vue?vue&type=script&lang=ts&"
export * from "./ActivityHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityHistory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports